document.addEventListener('DOMContentLoaded', () => {
    const heroSwiper = new Swiper('.hero-swiper', {
        loop: true,
        slidesPerView: 1,
        speed: 800,
        autoplay: {
			delay: 4000,
		},
        effect: "fade",
		fadeEffect: {
			crossFade: true,
		}
    });

    const imgSwiper = new Swiper('.img-swiper', {
        loop: true,
        slidesPerView: 1,
        speed: 800,
        autoplay: {
			delay: 3000,
		},
        effect: "fade",
		fadeEffect: {
			crossFade: true,
		}
    });

    const homeGallerySwiper = new Swiper('.home-gallery-swiper', {
        loop: true,
        slidesPerView: 1,
        speed: 800,
        autoplay: {
			delay: 3000,
		}
    });

    const mapSwiper = new Swiper('.map-swiper', {
        loop: true,
        slidesPerView: 1,
        speed: 800,
        effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
        navigation: {
            nextEl: ".map-next",
            prevEl: ".map-prev",
        }
    });


    const gallerySwiper = new Swiper('.gallery-swiper', {
        loop: true,
        slidesPerView: 1,
        speed: 800,
        navigation: {
            nextEl: ".gallery-next",
            prevEl: ".gallery-prev",
        }
    });
});